import { render } from "./BaseLoader.vue?vue&type=template&id=5b1e0efd&scoped=true"
const script = {}

import "./BaseLoader.vue?vue&type=style&index=0&id=5b1e0efd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1e0efd"]])

export default __exports__